<div class="header">
  <div class="title" data-testid="create-task-list-title">Create Task List</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1" data-testid="close-modal-button">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

@if (createTaskListForm) {
  <form [formGroup]="createTaskListForm">
    <!-- Subject -->
    <ng-container *ngIf="taskListTemplates; else loadingTaskTemplates">
      <mat-form-field class="flex-auto">
        <mat-label>Template</mat-label>
        <mat-select
          [formControlName]="'task_list_template_id'"
          (selectionChange)="onSelectedTaskListTemplate($event)"
          data-testid="template-select"
        >
          <mat-option value="">--- No Template ---</mat-option>
          <mat-option
            *ngFor="let taskListTemplate of taskListTemplates"
            [value]="taskListTemplate.id"
            [attr.data-testid]="'template-option-' + taskListTemplate.id"
          >
            {{ taskListTemplate.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>List Name</mat-label>
        <input matInput [formControlName]="'name'" data-testid="list-name-input" />
      </mat-form-field>
    </ng-container>

    <!-- Body -->
    <div class="actions justify-end">
      <div class="buttons">
        <!-- Discard -->
        <button class="discard-button" mat-button type="button" (click)="discard()" data-testid="cancel-button">
          <span>Cancel</span>
        </button>

        <!-- Send -->
        <button
          class="send-button"
          mat-flat-button
          [color]="'primary'"
          [disabled]="isSaveBtnDisabled"
          DebounceClick
          (debounceLoading)="isDebounceLoading($event)"
          (debounceClick)="save()"
          data-testid="create-button"
        >
          <span>Create</span>
        </button>
      </div>
    </div>
  </form>
}
<ng-template #loadingTaskTemplates>
  <div class="ph-item border-0 p-0 m-0">
    <div class="ph-col-12 p-0">
      <div class="ph-row mb-4">
        <div class="ph-col-2"></div>
        <div class="ph-col-12 big h-8"></div>
      </div>
      <div class="ph-row">
        <div class="ph-col-2"></div>
        <div class="ph-col-12 big h-8"></div>
      </div>
    </div>
  </div>
</ng-template>
